export {
    PatternLogos,
    type InlineLogoProps,
    type PatternCTAMobileProps
} from "./logos";
export { PatternLogos as default } from "./logos";
